import { FILTER_TYPES } from 'components/FilterPod';
const toolType = [
  {
    value: 'PAYMENT_TOOL_CHEQUE',
    label: 'چک'
  },
];
const filters = () => [
  {
    title: 'ابزار پرداخت',
    label: 'ابزار پرداخت',
    keyName: 'toolType',
    query: 'toolType',
    id: 3398,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: toolType,
    },
  },

  {
    title: 'تاریخ ایجاد پروفایل',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'creationDate',
    query: {
      start: 'fromDate',
      end: 'toDate',
    },
    id: {
      start: 3, // fake
      end: 4, // fake
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },

];

export default filters;
